// Configuration: Set the amplifier product handle here
const AMPLIFIER_PRODUCT_HANDLE = "amplifier";

document.addEventListener("DOMContentLoaded", function () {
  const quantityButtons = document.querySelectorAll(".quantity-btn");

  quantityButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();

      const row = this.closest("tr");
      const quantityDisplay = row.querySelector(".quantity-value");
      const quantityInput = row.querySelector(".quantity-input");
      const currentQuantity = parseInt(quantityDisplay.textContent);
      const action = this.dataset.action;
      const productHandle = row.dataset.productHandle || "";
      const lineItemKey = row.dataset.lineItemKey || "";

      let newQuantity = currentQuantity;

      if (action === "increase") {
        newQuantity = currentQuantity + 1;
      } else if (action === "decrease") {
        newQuantity = Math.max(0, currentQuantity - 1);
      }

      // Update display immediately for responsiveness
      quantityDisplay.textContent = newQuantity;
      quantityInput.value = newQuantity;

      // Check if this is the amplifier product
      const isAmplifier = productHandle === AMPLIFIER_PRODUCT_HANDLE;

      // Calculate the quantity difference (how many were removed)
      const quantityDiff = currentQuantity - newQuantity;

      // If reducing quantity of a non-amplifier product, also reduce amplifier by same amount
      if (quantityDiff > 0 && !isAmplifier) {
        reduceProductWithAmplifier(lineItemKey, newQuantity, quantityDiff);
      } else {
        updateCartItemByKey(lineItemKey, newQuantity);
      }
    });
  });
});

// Reduce a product quantity and adjust the amplifier based on total remaining main product quantity
async function reduceProductWithAmplifier(
  lineItemKey,
  newQuantity,
  quantityToRemove,
) {
  try {
    // First, get current cart to find amplifier and total main product quantities
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();

    let amplifierItem = null;
    let amplifierKey = null;
    let totalMainQuantity = 0;

    cart.items.forEach((item) => {
      const isAmplifier =
        item.handle === AMPLIFIER_PRODUCT_HANDLE ||
        item.product_title.toLowerCase().includes("amplifier");

      if (isAmplifier) {
        amplifierItem = item;
        amplifierKey = item.key;
      } else {
        // Sum all non-amp quantities, using the updated quantity for the item being changed
        totalMainQuantity +=
          item.key === lineItemKey ? newQuantity : item.quantity;
      }
    });

    // Build updates object using line item keys
    const updates = {};
    updates[lineItemKey] = newQuantity;

    // Only reduce the amp if it would exceed the total remaining main product quantity.
    // This ensures the amp isn't touched when other speakers are still in the cart.
    if (amplifierItem && amplifierKey) {
      const newAmplifierQuantity = Math.min(
        amplifierItem.quantity,
        totalMainQuantity,
      );
      if (newAmplifierQuantity !== amplifierItem.quantity) {
        updates[amplifierKey] = newAmplifierQuantity;
      }
    }

    // Update cart
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: updates }),
    });

    const updatedCart = await response.json();

    // Update the display without reloading
    updateCartDisplay(updatedCart);
  } catch (error) {
    console.error("Error reducing product with amplifier:", error);
    // Fallback to simple update
    updateCartItemByKey(lineItemKey, newQuantity);
  }
}

// Update cart item using line item key (more reliable than line number)
function updateCartItemByKey(key, quantity) {
  const updates = {};
  updates[key] = quantity;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates: updates }),
  })
    .then((response) => response.json())
    .then((cart) => {
      updateCartDisplay(cart);
    })
    .catch((error) => {
      console.error("Error updating cart:", error);
    });
}

function updateCartDisplay(cart) {
  // Update based on line item keys for accuracy
  const rows = document.querySelectorAll(".cart-table tbody tr");

  // Create a map of cart items by key for easy lookup
  const cartItemsByKey = {};
  cart.items.forEach((item) => {
    cartItemsByKey[item.key] = item;
  });

  // Update each row based on its line item key
  rows.forEach((row) => {
    const lineItemKey = row.dataset.lineItemKey;
    const item = cartItemsByKey[lineItemKey];

    if (item) {
      // Update total
      const totalCell = row.querySelector("td:last-child");
      if (totalCell) {
        totalCell.textContent = formatMoney(item.line_price);
      }

      // Update price
      const priceCell = row.querySelector("td:nth-child(4)");
      if (priceCell) {
        priceCell.textContent = formatMoney(item.price);
      }

      // Update quantity display
      const quantityDisplay = row.querySelector(".quantity-value");
      const quantityInput = row.querySelector(".quantity-input");
      if (quantityDisplay) {
        quantityDisplay.textContent = item.quantity;
      }
      if (quantityInput) {
        quantityInput.value = item.quantity;
      }
    } else {
      // Item was removed from cart, remove the row
      row.remove();
    }
  });

  // Update subtotal
  const subtotalContainers = document.querySelectorAll(
    ".cart-summary-content-container",
  );
  subtotalContainers.forEach((container) => {
    const label = container.querySelector("p:first-child");
    const value = container.querySelector("p:last-child");
    if (label && value && label.textContent.trim() === "Subtotal") {
      value.textContent = formatMoney(cart.total_price);
    }
    if (label && value && label.textContent.trim() === "VAT") {
      value.textContent = formatMoney(cart.total_tax || 0);
    }
  });

  // Update total
  const totalContainer = document.querySelector(".cart-total");
  if (totalContainer) {
    const totalValue = totalContainer.querySelector("p:last-child");
    if (totalValue) {
      totalValue.textContent = formatMoney(cart.total_price);
    }
  }

  // If cart is empty, reload the page to show empty cart message
  if (cart.item_count === 0) {
    window.location.reload();
  }
}

function formatMoney(cents) {
  return "£" + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
